<template lang="pug">
div
  TimeDelta(
    v-if="previousPostCreatedAt",
    :prevDateTime="previousPostCreatedAt",
    :currDateTime="post.created_at"
  )
  Post.mb-4(
    :post="post",
    :update-post="updatePost",
    @postUpdated="(val) => $emit('postUpdated', val)",
    @delete-post="(val) => $emit('delete-post', val)"
    :viewContext="viewContext",
  )
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { Post as IPost } from "suus-api"
import Post from "../../components/Post/Post.vue"
import TimeDelta from "../../components/UI/TimeDelta.vue"
import { ViewContext } from "concerns/useContextName"
import { UpdatePostFunction } from "features/posts/form/post-form.types"

export default defineComponent({
  name: "PostListItem",
  components: {
    Post,
    TimeDelta,
  },
  props: {
    post: { type: Object as PropType<IPost>, default: () => null as IPost },
    viewContext: { type: Object as PropType<ViewContext> },
    previousPostCreatedAt: { type: String, required: false },
    updatePost: {
      type: Function as PropType<UpdatePostFunction>,
    },
  },
})
</script>
